// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2Od02","errorLogs":"styles_errorLogs__2xlVz"};